export default __webpack_public_path__ + "static/2-20458f77659ce297d5c967a6b79c5156.jpeg";